import "../index.css";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import { PageNav } from "../components/PageNav";

function Bullets({ items }: { items: string[] }) {
  return (
    <ul className="bsp-list font_family_base">
      {items.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </ul>
  );
}

export default function Services() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <PageNav />
      <div className="bsp-page">
        <div className="bsp-section bsp-container-narrow font_family_base">
          <div className="bsp-eyebrow bsp-center">Services</div>
          <h1 className="bsp-h1 bsp-center">
            Executive Coaching &amp; Organizational Development
          </h1>
          <p className="bsp-lead bsp-center">
            BStrong Performance works with individual leaders, teams, and
            organizations to optimize leadership efforts, align behaviors to
            better practices grounded in theory and proven models, and mature
            leadership practices within the organizational culture.
          </p>
        </div>

        <div className="bsp-section-narrow bsp-container-narrow font_family_base">
          <h2 className="bsp-h2">We partner with you to:</h2>
          <Bullets
            items={[
              "Deliver practical consultations on organizational issues such as enterprise change management, organizational culture, and leadership effectiveness.",
              "Facilitate dynamic, group team building activities that incorporate the principles of individual and/or group coaching, healthy leadership and/or higher team performance.",
              "One to one executive coaching to senior and emerging leaders.",
            ]}
          />
        </div>

        <div className="bsp-section-narrow bsp-container-narrow font_family_base">
          <div className="bsp-card-alt">
            <h2 className="bsp-h2">What You Gain</h2>
            <Bullets
              items={[
                "A grounded thought partner bringing nearly three decades of leadership development experience",
                "Neuroscience informed perspectives",
                "Clearer thinking and mature leadership practices",
                "More confident, intentional decision-making aligned to clear measures",
                "An authentic, sustainable, and balanced leadership identity",
              ]}
            />
          </div>
        </div>

        <div className="bsp-section bsp-container font_family_base">
          <h2 className="bsp-h2 bsp-center" style={{ marginBottom: 32 }}>
            Engagement Options
          </h2>
          <div className="bsp-grid bsp-grid-3">
            <div className="bsp-card">
              <h3 className="bsp-h3">
                One-on-One Executive/Organizational Coaching
              </h3>
              <p
                className="bsp-body"
                style={{ marginBottom: 16, fontStyle: "italic" }}
              >
                Typically includes:
              </p>
              <Bullets
                items={[
                  "Assessment and debrief of a personal assessment (individual leader or 360 tools recommended based upon need)",
                  "One-on-one coaching sessions; typically 90-minute sessions twice a month over a six month period",
                  "Leader alignment sessions between leader, sponsor and coach",
                  "Co-development of an action plan to help you meet your leadership goals",
                  "Specific actions assigned between coaching sessions (mindful practices, reflection questions, targeted reading, journaling)",
                ]}
              />
            </div>

            <div className="bsp-card">
              <h3 className="bsp-h3">One-on-One Individual Leadership Coaching</h3>
              <p
                className="bsp-body"
                style={{ marginBottom: 16, fontStyle: "italic" }}
              >
                Typically includes:
              </p>
              <Bullets
                items={[
                  "One-on-one coaching sessions; typically 90-minute sessions twice a month over a six month period",
                  "Assessment and debrief of a personal assessment (individual leader or 360 tools recommended based upon need)",
                  "Framing of actions and behaviors within the BStrong framework",
                  "Co-development of an action plan to help you meet your leadership goals",
                  "Specific actions assigned between coaching sessions",
                ]}
              />
            </div>

            <div className="bsp-card">
              <h3 className="bsp-h3">Team &amp; Organization Leadership Engagement</h3>
              <p
                className="bsp-body"
                style={{ marginBottom: 16, fontStyle: "italic" }}
              >
                Typically includes:
              </p>
              <Bullets
                items={[
                  "Alignment sessions between leaders, sponsors, and coach",
                  "Individual and team assessments, debriefs, and facilitated action planning",
                  "One-on-one coaching sessions for participants; typically two hour-long sessions twice a month during the scope of engagement",
                  "Framing of actions and behaviors within the BStrong framework",
                  "Specific actions aligned within the scope of engagement assigned between coaching sessions",
                ]}
              />
            </div>
          </div>
        </div>

        <div className="bsp-section-narrow bsp-container-narrow font_family_base">
          <h2 className="bsp-h2">Who I Coach</h2>
          <p className="bsp-body" style={{ marginBottom: 20 }}>
            I work with business owners, senior leaders, emerging executives,
            new-to-role and first-time leaders who are exploring their
            leadership practices to include:
          </p>
          <Bullets
            items={[
              "New roles or expanded scope",
              "Career transitions",
              "Team or culture challenges",
              "Identity shifts",
              "Aligning balance and strategic transformation into meaningful goals",
            ]}
          />
        </div>

        <div className="bsp-section bsp-cta-band bsp-center">
          <h2 className="bsp-h2 font_family_base">
            Ready to talk through what's next?
          </h2>
          <p className="bsp-lead font_family_base" style={{ marginBottom: 8 }}>
            Let's find the engagement that fits where you are.
          </p>
          <div className="bsp-hero-actions">
            <Link to="/contact" className="bsp-btn bsp-btn-primary font_family_base">
              Schedule a Conversation
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
